<template>
  <BaseEdit />
</template>
<script>
  import BaseEdit from './baseEdit';

  export default {
    name: 'addTransaction',
    components: {
      BaseEdit,
    },
  };
</script>
